<div class="portlet-boundary_netxinvestorf2ScreenerNavigation_WAR_f2portlets_ screenerSelector ">
        <component-title  *ngIf="isAdaTheme" [portletTitle]="'screener-navigation' | pershingTranslate"></component-title>     
    <ul class="contain">
        <li *ngIf="isEntitledStockScreener"><span>{{ 'NXI_NAVIGATION.SCREENERS_NAV.STOCK_SCREENS' | pershingTranslate }}</span>
            <ul>
                <li *ngIf="currentUrl.includes('stockspredefined') ; else notStocksPredefined ">
                    <a class="active strong" href="javascript:void(0);"
                        (click)="handleChildNavigation('stockspredefined')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.PREDEFINED_SCREENS' | pershingTranslate }}</a>
                </li>
                <ng-template #notStocksPredefined>
                    <li><span class="icon-arrow-right icon-small"></span><a href="javascript:void(0);"
                            (click)="handleChildNavigation('stockspredefined')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.PREDEFINED_SCREENS' | pershingTranslate }}</a></li>
                </ng-template>

                <li *ngIf="currentUrl.includes('stocksadvanced') ; else notStocksadvanced ">
                    <a class="active strong" href="javascript:void(0);"
                        (click)="handleChildNavigation('stocksadvanced')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.ADVANCED_SCREENER' | pershingTranslate }}</a>
                </li>
                <ng-template #notStocksadvanced>
                    <li><span class="icon-arrow-right icon-small"></span><a href="javascript:void(0);"
                            (click)="handleChildNavigation('stocksadvanced')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.ADVANCED_SCREENER' | pershingTranslate }}</a></li>
                </ng-template>
            </ul>
        </li>
        <li *ngIf="isEntitledETFScreener"><span>{{ 'NXI_NAVIGATION.SCREENERS_NAV.ETF_SCREENS' | pershingTranslate }}</span>
            <ul>
                <li *ngIf="currentUrl.includes('etfpredefined') ; else notEtfpredefined ">
                    <a class="active strong" href="javascript:void(0);"
                        (click)="handleChildNavigation('etfpredefined')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.PREDEFINED_SCREENS' | pershingTranslate }}</a>
                </li>
                <ng-template #notEtfpredefined>
                    <li><span class="icon-arrow-right icon-small"></span><a href="javascript:void(0);"
                            (click)="handleChildNavigation('etfpredefined')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.PREDEFINED_SCREENS' | pershingTranslate }}</a></li>
                </ng-template>

                <li *ngIf="currentUrl.includes('etfadvanced') ; else notEtfadvanced ">
                    <a class="active strong" href="javascript:void(0);"
                        (click)="handleChildNavigation('etfadvanced')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.ADVANCED_SCREENER' | pershingTranslate }}</a>
                </li>
                <ng-template #notEtfadvanced>
                    <li><span class="icon-arrow-right icon-small"></span><a href="javascript:void(0);"
                            (click)="handleChildNavigation('etfadvanced')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.ADVANCED_SCREENER' | pershingTranslate }}</a></li>
                </ng-template>
            </ul>
        </li>
        <li *ngIf="isEntitledMFScreener"><span>{{ 'NXI_NAVIGATION.SCREENERS_NAV.MUTUAL_FUNDS_SCREENS' | pershingTranslate }}</span>
            <ul>
                <li *ngIf="currentUrl.includes('mfpredefined') ; else notMfpredefined ">
                    <a class="active strong" href="javascript:void(0);"
                        (click)="handleChildNavigation('mfpredefined')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.PREDEFINED_SCREENS' | pershingTranslate }}</a>
                </li>
                <ng-template #notMfpredefined>
                    <li><span class="icon-arrow-right icon-small"></span><a href="javascript:void(0);"
                            (click)="handleChildNavigation('mfpredefined')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.PREDEFINED_SCREENS' | pershingTranslate }}</a></li>
                </ng-template>

                <li *ngIf="currentUrl.includes('mfadvanced') ; else notMfadvanced ">
                    <a class="active strong" href="javascript:void(0);"
                        (click)="handleChildNavigation('mfadvanced')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.ADVANCED_SCREENER' | pershingTranslate }}</a>
                </li>
                <ng-template #notMfadvanced>
                    <li><span class="icon-arrow-right icon-small"></span><a href="javascript:void(0);"
                            (click)="handleChildNavigation('mfadvanced')">{{ 'NXI_NAVIGATION.SCREENERS_NAV.ADVANCED_SCREENER' | pershingTranslate }}</a></li>
                </ng-template>
            </ul>
        </li>
    </ul>
</div>